import { allProfiles } from '../../library/Profiles';
import { NoProfilePermissions } from '../../store/modules/permissions/NoProfile';
import { Dispatch } from 'redux';
import { AUTH_SET_PERMISSIONS, AUTH_SET_USER } from './AuthReducer';
import { User, UserProfile } from './types';

export const setPermissions = (userData: UserProfile) => {
  return (dispatch: Dispatch) => {
    const role = userData?.perfil;
    const permissions = allProfiles.find(profile => profile.id === role) || NoProfilePermissions;
    dispatch({
      type: AUTH_SET_PERMISSIONS,
      payload: permissions,
    });
  };
};

export const setUser = (user: User) => {
  return {
    type: AUTH_SET_USER,
    payload: {
      access_token: user.access_token,
      token_type: user.token_type,
      profile: user.profile,
    },
  };
};

